/**
 * Company marks — the initials block a company is drawn as wherever its logo
 * is absent or unwanted.
 *
 * This lives in the shared workspace rather than beside the board component
 * because two very different renderers draw the same mark: the browser, on
 * every board and card, and the share-card Lambda, which paints a listing into
 * a PNG for the link previews. A company whose initials are indigo in the
 * product must not be teal in the image a recruiter pastes into Slack, so both
 * sides read the palette and the hash from here.
 */
/**
 * The palette a logo-less company falls back to. Picked from the artboards so
 * a board of initials still reads as one composition rather than a paint box.
 */
export const MARK_COLOURS = [
    '#0d253d',
    '#533afd',
    '#0f766e',
    '#8b5cf6',
    '#b45309',
    '#0369a1',
    '#1a6f5a',
    '#111827',
];
/** Stable per-company, so a mark never changes colour between renders. */
export function markColour(seed) {
    let hash = 0;
    for (let index = 0; index < seed.length; index += 1) {
        hash = (hash * 31 + seed.charCodeAt(index)) | 0;
    }
    return MARK_COLOURS[Math.abs(hash) % MARK_COLOURS.length];
}
/** "Northbeam Systems" → "NS"; "Vantable" → "VA". */
export function initials(name) {
    const words = name
        .split(/[\s—–-]+/)
        .map((word) => word.replace(/[^\p{L}\p{N}]/gu, ''))
        .filter((word) => word !== '');
    if (words.length === 0)
        return '??';
    if (words.length === 1)
        return words[0].slice(0, 2).toUpperCase();
    return `${words[0][0] ?? ''}${words[1][0] ?? ''}`.toUpperCase();
}
//# sourceMappingURL=marks.js.map